import m from "../../geodata/es2015/georgiaHigh";
window.am4geodata_georgiaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/georgiaHigh.js
// module id = null
// module chunks = 